export abstract class ObjectPool<T extends PoolableObject> {
    private objects: T[];

    constructor(initialCapacity: number) {
        this.objects = [];

        for (let i = 0; i < initialCapacity; i++) {
            this.objects.push(this.create());
        }
    }

    protected abstract create(): T;

    public claim(): T {
        if (this.objects.length > 0) {
            return this.objects.pop();
        } else {
            return this.create();
        }
    }

    public release(object: T) {
        object.clear();
        this.objects.push(object);
    }
}

export interface PoolableObject {
    clear(): void;
}